<div id="next-grid" class="wrapper ">

  <div class="grid" style="--height:{{ this.grid.height }}; --width:{{ this.grid.width }};">
    <div *ngFor="let square of grid.square_list" class="cell {{square.color}}"></div>
  </div>


</div>

